module.exports = __webpack_public_path__ + "static/media/pet-clothing.23057e6f.svg";